import React, { useState, useRef, useEffect } from "react";
import "../../css/designSystem/Navbar.css";
import logo from "../../assets/images/navbar_logo.png";
import SecondaryButton from "./buttons/SecondaryButton";
import { useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showMortgageDropdown, setShowMortgageDropdown] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showToolsDropdown, setShowToolsDropdown] = useState(false);
  const [showCalculatorsDropdown, setShowCalculatorsDropdown] = useState(false);
  const mortgageRef = useRef(null);
  const servicesRef = useRef(null);
  const toolsRef = useRef(null);
  const calculatorsRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (mortgageRef.current && !mortgageRef.current.contains(event.target)) {
        setShowMortgageDropdown(false);
      }
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setShowServicesDropdown(false);
      }
      if (toolsRef.current && !toolsRef.current.contains(event.target)) {
        setShowToolsDropdown(false);
      }
      if (
        calculatorsRef.current &&
        !calculatorsRef.current.contains(event.target)
      ) {
        setShowCalculatorsDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!location.hash) return;

    const sectionId = location.hash.slice(1);
    window.setTimeout(() => {
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }, [location.pathname, location.hash]);





  // const calculatorsList = [
  //   { name: "Mortgage Borrow", path: "/calculators/mortgage-borrow" },
  //   { name: "Mortgage Repayment", path: "/calculators/mortgage-repayment" },
  //   { name: "Overpayment", path: "/calculators/overpayment" },
  //   { name: "Stamp Duty", path: "/calculators/stamp-duty" },
  //   {
  //     name: "How Much Will It Cost",
  //     path: "/calculators/how-much-will-it-cost",
  //   },
  //   {
  //     name: "How Much Can I Borrow",
  //     path: "/calculators/how-much-can-i-borrow",
  //   },
  //   { name: "Equity Release", path: "/calculators/equity-release" },
  //   { name: "Relevant Life Tax", path: "/calculators/relevant-life-tax" },
  //   { name: "Pensions Shortfall", path: "/calculators/pensions-shortfall" },
  //   { name: "Inheritance Tax", path: "/calculators/inheritance-tax" },
  //   { name: "Investment", path: "/calculators/investment" },
  // ];

  const handleNavigate = (path) => {
    setShowMortgageDropdown(false);
    setShowServicesDropdown(false);
    setShowToolsDropdown(false);
    setShowCalculatorsDropdown(false);
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  const handleSectionNavigate = ({ path, sectionId }) => {
    const nextPath = sectionId ? `${path}#${sectionId}` : path;
    handleNavigate(nextPath);

    if (location.pathname === path && sectionId) {
      window.setTimeout(() => {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
    }
  };

  const handleContactClick = () => {
    setShowMortgageDropdown(false);
    setShowServicesDropdown(false);
    setShowToolsDropdown(false);
    setShowCalculatorsDropdown(false);
    setIsMobileMenuOpen(false);
    document
      .getElementById("contact-us")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const navTextClass = (path, exact = true) => {
    const isActive = exact
      ? location.pathname === path
      : location.pathname.startsWith(path);

    return `nav-text ${isActive ? "is-active" : ""}`;
  };

  const dropdownItemClass = (path) => {
    return `navbar-dropdown-item content ${
      location.pathname === path ? "is-active" : ""
    }`;
  };

  const sectionDropdownItemClass = ({ path, sectionId }) => {
    const isActive =
      location.pathname === path &&
      (!sectionId || location.hash === `#${sectionId}`);

    return `navbar-dropdown-item content ${isActive ? "is-active" : ""}`;
  };

  return (
    <nav className="navbar">
      <div className="navbar-main-row">
        <div className="navbar-left">
          <img
            src={logo}
            alt="TAG Mortgages logo"
            className="navbar-logo"
            onClick={() => {
              handleNavigate("/");
            }}
          />
        </div>

        <button
          type="button"
          className={`navbar-toggle ${isMobileMenuOpen ? "is-open" : ""}`}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
          onClick={() => {
            setIsMobileMenuOpen((prev) => !prev);
            setShowMortgageDropdown(false);
            setShowServicesDropdown(false);
            setShowToolsDropdown(false);
            setShowCalculatorsDropdown(false);
          }}
        >
          <span className="navbar-toggle-line line-1" />
          <span className="navbar-toggle-line line-2" />
          <span className="navbar-toggle-line line-3" />
        </button>
      </div>

      <div className={`navbar-content ${isMobileMenuOpen ? "is-open" : ""}`}>
        <ul className="navbar-links">
          <li ref={mortgageRef} style={{ position: "relative" }}>
            <span
              className={navTextClass("/about-us")}
              onClick={() => handleNavigate("/about-us")}
            >
              About Us
            </span>
          </li>
          <li ref={servicesRef} style={{ position: "relative" }}>
            <span
              className={navTextClass("/our-services")}
              onClick={() => handleNavigate("/our-services")}
            >
              our services
            </span>
          </li>
          <li ref={toolsRef} style={{ position: "relative" }}>
            <span
              className={navTextClass("/mortgage-calculators")}
              onClick={() => handleNavigate("/mortgage-calculators")}
              style={{ userSelect: "none" }}
            >
              mortgage calculators
            </span>
          </li>
          {/* <li>
            <span
              className={navTextClass("/blogs")}
              onClick={() => handleNavigate("/blogs")}
            >
              Blogs
            </span>
          </li> */}
        </ul>

        <div className="navbar-actions gap-m row-center">
          <SecondaryButton onClick={handleContactClick} text="Contact Us" />
        </div>

        {/* <div className="navbar-mobile-menu">
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/services/mortgages");
            }}
          >
            Find A Mortgage
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/services/protection");
            }}
          >
            Insurance & Protection
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/about-us");
            }}
          >
            Honest Pricing
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/calculators/mortgage-borrow");
            }}
          >
            Useful Tools
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/about-us");
            }}
          >
            About Us
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/blogs");
            }}
          >
            Blogs
          </button>

          <button
            type="button"
            className="navbar-mobile-cta"
            onClick={() => {
              handleNavigate("/contact-us");
            }}
          >
            Contact Us
          </button>
        </div> */}
      </div>
    </nav>
  );
};

export default Navbar;
